// Rows represent individual cash flow transactions from the database
// The first row will be a header row, then data rows follow
export const CashFlowRowConfig = (items: any) => [
  // Header row configuration
  {
    largeHeader: true,
    ignoreRowCopy: true,
    className: 'division-bottom-only text-right',
    readOnly: true,
  },
  // Data rows (actual cash flow items)
  // Add isDeletableRow flag to allow deletion of non-virtual rows
  ...(items || []).map((item: any) => ({
    ...item,
    isDeletableRow: !item?.is_virtual,
  })),
];
